import $ from 'jquery';

$(".menu-toggler").click(function () {
	$(this).toggleClass("menu-toggler--opened");
	$(".handheld-header__nav-wrapper").toggleClass("menu--opened");
});

$('.handheld-header__nav a[href="#"]').click(function (e) {
	e.preventDefault();
});
